export enum SignInLocators {
	loginButton = 'loginButton',
}
